module.exports = __webpack_public_path__ + "static/img/2.5882033.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/sp/2.png
// module id = SEfc
// module chunks = 0